import { Button } from '@mui/material';
import NorthIcon from '@mui/icons-material/North';
import { useEffect, useState } from 'react';

const BackToTopButton = (props) => {
  const { value } = props ?? {};
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const topValue = value ? value : 170;
    setShowButton(scrollY > topValue);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {showButton && (
        <Button
          onClick={scrollToTop}
          sx={{
            bottom: '70px',
            right: '35px',
            width: '40px',
            height: '40px',
            zIndex: '8',
            minWidth: '40px',
            position: 'fixed',
            bgcolor: '#eeeded !important',
            border: '1px solid #0ad3bb',
            borderRadius: '50%',
            transition: '0.3s ease-in-out'
          }}
        >
          <NorthIcon sx={{ color: '#0ad3bb' }} />
        </Button>
      )}
    </>
  );
};

export default BackToTopButton;
